<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Mechanical Connections</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (handArrangementSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Arrangement:</label>
            <select class="halfWidthInputField" #handArrangementInput
              [class.invalidConfigurationSelection]="isInvalidSelection(handArrangementSelection.Name)"
              (change)="selectionChanged(handArrangementSelection, handArrangementInput.value)"
              [value]="handArrangementSelection.Value.toString()">
              @for (allowable of handArrangementSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="handArrangementSelection.Value && handArrangementSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (paintOptionsSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Paint Options:</label>
            <select class="halfWidthInputField" #paintOptionsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(paintOptionsSelection.Name)"
              (change)="selectionChanged(paintOptionsSelection, paintOptionsInput.value)"
              [value]="paintOptionsSelection.Value.toString()">
              @for (allowable of paintOptionsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="paintOptionsSelection.Value && paintOptionsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (returnAirSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Return Air:</label>
            <select class="halfWidthInputField" #returnAirInput
              [class.invalidConfigurationSelection]="isInvalidSelection(returnAirSelection.Name)"
              (change)="selectionChanged(returnAirSelection, returnAirInput.value)"
              [value]="returnAirSelection.Value.toString()">
              @for (allowable of returnAirSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="returnAirSelection.Value && returnAirSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (supplyAirSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Supply Air:</label>
            <select class="halfWidthInputField" #supplyAirInput
              [class.invalidConfigurationSelection]="isInvalidSelection(supplyAirSelection.Name)"
              (change)="selectionChanged(supplyAirSelection, supplyAirInput.value)"
              [value]="supplyAirSelection.Value.toString()">
              @for (allowable of supplyAirSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="supplyAirSelection.Value && supplyAirSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (mixingBoxSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Outside Air:</label>
            <select class="halfWidthInputField" #mixingBoxInput
              [class.invalidConfigurationSelection]="isInvalidSelection(mixingBoxSelection.Name)"
              (change)="selectionChanged(mixingBoxSelection, mixingBoxInput.value)"
              [value]="mixingBoxSelection.Value.toString()">
              @for (allowable of mixingBoxSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="mixingBoxSelection.Value && mixingBoxSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (handArrangementImagePath() && handArrangementImagePath().length > 0) {
          <img class="handArrangementImage"
            [src]="handArrangementImagePath()" alt="UnitImage"/>
        }
      </div>
    </div>
  }
</div>
